// Last term's dec page sits apart, closed by default (Yehuda, Oct 28): the portal fetches it only
// to compare with last year, and next to the renewal dec page it confused the VA. Used in step 1
// and in Files, below this term's files. It is never attached to the insured's email.
import { useState, type ReactNode } from 'react';
import { ChevronRightIcon } from '../shell/icons';
import { lastTermTitle } from './fetch-lines';

export function LastTermFold({ children, inset }: { children: ReactNode; inset?: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={inset ? 'lastterm inset' : 'lastterm'}>
      <button
        type="button"
        className="det2-h"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <ChevronRightIcon className="ico s12" />
        {lastTermTitle}
      </button>
      {open && (
        <div className="det2-b">
          <span className="t12 muted">
            Only for comparing with last year. Never sent to the insured.
          </span>
          {children}
        </div>
      )}
    </div>
  );
}
